import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';

const Telegram: React.FC<IconProps> = ({ color, size, style }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      width={size ?? '57'}
      height={size ?? '64'}
      fill="none"
      viewBox="0 0 57 64"
      data-testid="telegram-icon"
    >
      <g clipPath="url(#clip0_8017_31616)">
        <path
          fill={color ?? '#fff'}
          d="M56.337 12.325l-8.45 39.85c-.637 2.813-2.3 3.513-4.662 2.188L30.35 44.874l-6.213 5.975c-.687.688-1.262 1.262-2.587 1.262L22.475 39l23.862-21.563c1.038-.925-.225-1.437-1.612-.512L15.225 35.5l-12.7-3.975c-2.763-.862-2.813-2.762.575-4.087L52.775 8.3c2.3-.863 4.312.512 3.562 4.025z"
        />
      </g>
      <defs>
        <clipPath id="clip0_8017_31616">
          <path fill="#fff" d="M0 0H56V64H0z" transform="translate(.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Telegram;
